import script from "./end-election-button.vue?vue&type=script&lang=js"
export * from "./end-election-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__